export default __webpack_public_path__ + "static/people-first@2x-1c63c04565d4f2bfb1332a19ef0a58a2.png";